var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventDashboardInActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11263",
    "data-name": "Path 11263",
    d: "M9.944,20.212H2v-.577A13.269,13.269,0,0,1,7.037,9.251l.49-.381L12,15.5l-.369.335a5.1,5.1,0,0,0-1.667,3.813Zm-6.79-1.154h5.66a6.237,6.237,0,0,1,1.667-3.738L7.25,10.537a12.115,12.115,0,0,0-4.1,8.521Z",
    transform: "translate(-0.846 -3.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11264",
    "data-name": "Path 11264",
    d: "M23.571,12.545l-.467-.219a5.037,5.037,0,0,0-4.488,0l-.45.219L13.7,5.968l.531-.3a13.027,13.027,0,0,1,13.269,0l.525.312Zm-2.694-1.9a6.11,6.11,0,0,1,2.308.444l3.208-4.737a12.058,12.058,0,0,0-11.037,0l3.225,4.737a6.115,6.115,0,0,1,2.3-.444Z",
    transform: "translate(-5.796 -1.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    "data-name": "Path 11265",
    d: "M43.233,20.314H36.31V19.16h5.769a11.706,11.706,0,0,0-3.888-8.383l-3.133,4.662-.958-.623L37.931,9.11l.49.381a12.837,12.837,0,0,1,4.812,10.263Z",
    transform: "translate(-14.427 -3.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11266",
    "data-name": "Path 11266",
    d: "M24.317,27.736a3.087,3.087,0,0,1-.992-.167,2.988,2.988,0,1,1,2.313-5.5L31.2,20.34l1.038,2.071-5.013,3.006a2.977,2.977,0,0,1-2.885,2.308Zm0-4.823a1.9,1.9,0,0,0-.79.179,1.835,1.835,0,1,0,2.613,1.887l.035-.283,4.558-2.735-.115-.237-5.112,1.6-.225-.138a1.829,1.829,0,0,0-.969-.277Z",
    transform: "translate(-9.023 -8.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11267",
    "data-name": "Path 11267",
    d: "M7.51,40.713l-.49-.381a13.154,13.154,0,0,1-4.973-9.173L2,30.53H9.956l.092.462a5.06,5.06,0,0,0,1.563,2.758l.369.34Zm-4.24-9.029A12.012,12.012,0,0,0,7.25,39.028l3.231-4.765A6.133,6.133,0,0,1,9.027,31.7Z",
    transform: "translate(-0.846 -12.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11268",
    "data-name": "Path 11268",
    d: "M37.177,40.713,32.7,34.09l.369-.34a5.227,5.227,0,0,0,1.563-2.763l.1-.456h7.95l-.063.629a13.367,13.367,0,0,1-4.973,9.173ZM34.2,34.263l3.231,4.777A12.288,12.288,0,0,0,41.412,31.7H35.642A6.479,6.479,0,0,1,34.2,34.263Z",
    transform: "translate(-13.835 -12.917)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3746",
    "data-name": "Rectangle 3746",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDashboardInActive);
export default __webpack_public_path__ + "static/media/event_dashboard_inActive.6b847bfbc2d41bd0358c51bd5cec5e98.svg";
export { ForwardRef as ReactComponent };